// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
Development Ribbon
========================================================================== */
.ribbon {
  background-color: rgba(170, 0, 0, 0.5);
  left: -3.5em;
  transform: rotate(-45deg);
  overflow: hidden;
  position: absolute;
  top: 40px;
  white-space: nowrap;
  width: 15em;
  z-index: 99999;
  pointer-events: none;
  opacity: 0.75;
}
.ribbon a {
  color: #fff;
  display: block;
  font-weight: 400;
  margin: 1px 0;
  padding: 10px 50px;
  text-align: center;
  text-decoration: none;
  text-shadow: 0 0 5px #444;
  pointer-events: none;
}

/* ==========================================================================
Navbar styles
========================================================================== */
.jh-navbar {
  background-color: #ffffff;
  border-bottom: 1px solid #ececec;
  box-shadow: 0 1px 3px rgba(48, 48, 52, 0.06);
  padding: 0.35em 1.25em;
}
.jh-navbar .profile-image {
  margin: -10px 0;
  height: 40px;
  width: 40px;
  border-radius: 50%;
}
.jh-navbar .dropdown-item.active,
.jh-navbar .dropdown-item.active:focus,
.jh-navbar .dropdown-item.active:hover {
  background-color: #bd8f6f;
  color: #fff;
}
.jh-navbar .dropdown-toggle::after {
  margin-left: 0.15em;
}
.jh-navbar .navbar-nav {
  padding: 0.5em;
  align-items: center;
}
.jh-navbar .navbar-nav .nav-item {
  margin-left: 1.5rem;
}
.jh-navbar a.nav-link {
  font-weight: 500;
  color: #303034;
  transition: color 0.15s ease-in-out;
}
.jh-navbar a.nav-link > span {
  margin-left: 5px;
}
.jh-navbar a.nav-link:hover, .jh-navbar a.nav-link:focus, .jh-navbar a.nav-link.active {
  color: #bd8f6f;
}
.jh-navbar .jh-navbar-toggler {
  color: #303034;
  font-size: 1.5em;
  padding: 10px;
}
.jh-navbar .jh-navbar-toggler:hover {
  color: #bd8f6f;
}

.navbar-brand {
  overflow: hidden;
}

.jh-navbar .navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}

.navbar-version {
  font-size: 0.65em;
  color: #9a9aa0;
  padding: 0 0 0 10px;
}

.brand-logo {
  display: inline-flex;
  align-items: center;
}
.brand-logo:hover {
  text-decoration: none;
}
.brand-logo .brand-icon {
  display: inline-flex;
  align-items: center;
}
.brand-logo .brand-icon img {
  height: 34px;
  width: auto;
}

.loading-bar {
  height: 3px;
  z-index: 1031;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/shared/layout/header/header.scss"],"names":[],"mappings":"AAKA;;4EAAA;AAGA;EACE,sCAAA;EACA,YAAA;EAKA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,oBAAA;EACA,aAAA;AAJF;AAKE;EACE,WAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;AAHJ;;AAOA;;4EAAA;AAGA;EACE,yBAtCU;EAuCV,gCAAA;EACA,4CAAA;EACA,sBAAA;AAJF;AAKE;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAHJ;AAKE;;;EAGE,yBApDiB;EAqDjB,WAAA;AAHJ;AAKE;EACE,mBAAA;AAHJ;AAKE;EACE,cAAA;EACA,mBAAA;AAHJ;AAII;EACE,mBAAA;AAFN;AAKE;EACE,gBAAA;EACA,cArEW;EAsEX,mCAAA;AAHJ;AAII;EACE,gBAAA;AAFN;AAII;EAGE,cA3Ee;AAuErB;AAOE;EACE,cAjFW;EAkFX,gBAAA;EACA,aAAA;AALJ;AAMI;EACE,cAnFe;AA+ErB;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,gBAAA;EACA,eAAA;AALF;;AAQA;EACE,iBAAA;EACA,cAnGuB;EAoGvB,mBAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;AALF;AAME;EACE,qBAAA;AAJJ;AAME;EACE,oBAAA;EACA,mBAAA;AAJJ;AAKI;EACE,YAAA;EACA,WAAA;AAHN;;AAQA;EACE,WAAA;EACA,aAAA;AALF","sourcesContent":["$header-color: #303034;\n$header-color-secondary: #9a9aa0;\n$header-color-hover: #bd8f6f; // brand primary\n$header-bg: #ffffff;\n\n/* ==========================================================================\nDevelopment Ribbon\n========================================================================== */\n.ribbon {\n  background-color: rgba(170, 0, 0, 0.5);\n  left: -3.5em;\n  -moz-transform: rotate(-45deg);\n  -ms-transform: rotate(-45deg);\n  -o-transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  overflow: hidden;\n  position: absolute;\n  top: 40px;\n  white-space: nowrap;\n  width: 15em;\n  z-index: 99999;\n  pointer-events: none;\n  opacity: 0.75;\n  a {\n    color: #fff;\n    display: block;\n    font-weight: 400;\n    margin: 1px 0;\n    padding: 10px 50px;\n    text-align: center;\n    text-decoration: none;\n    text-shadow: 0 0 5px #444;\n    pointer-events: none;\n  }\n}\n\n/* ==========================================================================\nNavbar styles\n========================================================================== */\n.jh-navbar {\n  background-color: $header-bg;\n  border-bottom: 1px solid #ececec;\n  box-shadow: 0 1px 3px rgba(48, 48, 52, 0.06);\n  padding: 0.35em 1.25em;\n  .profile-image {\n    margin: -10px 0;\n    height: 40px;\n    width: 40px;\n    border-radius: 50%;\n  }\n  .dropdown-item.active,\n  .dropdown-item.active:focus,\n  .dropdown-item.active:hover {\n    background-color: $header-color-hover;\n    color: #fff;\n  }\n  .dropdown-toggle::after {\n    margin-left: 0.15em;\n  }\n  .navbar-nav {\n    padding: 0.5em;\n    align-items: center;\n    .nav-item {\n      margin-left: 1.5rem;\n    }\n  }\n  a.nav-link {\n    font-weight: 500;\n    color: $header-color;\n    transition: color 0.15s ease-in-out;\n    > span {\n      margin-left: 5px;\n    }\n    &:hover,\n    &:focus,\n    &.active {\n      color: $header-color-hover;\n    }\n  }\n  .jh-navbar-toggler {\n    color: $header-color;\n    font-size: 1.5em;\n    padding: 10px;\n    &:hover {\n      color: $header-color-hover;\n    }\n  }\n}\n.navbar-brand {\n  overflow: hidden;\n}\n\n.jh-navbar .navbar-nav .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.navbar-version {\n  font-size: 0.65em;\n  color: $header-color-secondary;\n  padding: 0 0 0 10px;\n}\n\n.brand-logo {\n  display: inline-flex;\n  align-items: center;\n  &:hover {\n    text-decoration: none;\n  }\n  .brand-icon {\n    display: inline-flex;\n    align-items: center;\n    img {\n      height: 34px;\n      width: auto;\n    }\n  }\n}\n\n.loading-bar {\n  height: 3px;\n  z-index: 1031;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
